import React from "react";
// eslint-disable-next-line import/no-named-as-default
import Helmet from "react-helmet";
import { useIntl } from "react-intl";

const MetaTitle = () => {
  const intl = useIntl();
  return (
    <Helmet
      title={intl.formatMessage({ id: "boilerplate.components.Helmet.Title" })}
    />
  );
};
export default MetaTitle;
